<div class="qr-tile--left">
  <h5 class="qr-tile--left__title" [translate]="title"></h5>
  <app-spacer [spacerSize]="20"></app-spacer>
  <p [translate]="description"></p>
</div>
<div class="qr-tile--right">
  <img src="{{QRCodeImgUrl}}">
</div>

